import {FinalizeService} from "../../finalize_step_service";
import {protocolStepsData} from "./mock_protocol";
import {FINAL_STEP_UID} from "../../constants";

export class ProtocolDataServiceV2 extends FinalizeService {
  constructor(uid, name, next_btn, success_text, getPrevStepAnswer, createAccountFunc, validateAccountFunc, validateMissingData) {
    super(uid, name, next_btn, success_text, getPrevStepAnswer, createAccountFunc);
    this._createAccountStep = 'not-existing-uid'; // TODO: not used in new design
    this._validateAccountFunc = validateAccountFunc;
    this._validateAccountStep = FINAL_STEP_UID;
    this.__stepsData = protocolStepsData;
    this.__is_new_design = true;
    this._validateMissingData = validateMissingData;
  }
}